/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React from "react";
import Cell from "./Cell";
import { v4 as uuidv4 } from "uuid";

const Row = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.rowRef = React.createRef(null);
    this.scrollActiveRowToTopHandler = this.scrollActiveRowToTopHandler.bind(
      this
    );
  }

  scrollActiveRowToTopHandler() {
    let activeRowElement = this.rowRef.current;
    //get container height from props and use to position row into middle
    let containerHeight = this.props.containerHeight;
    let topPos = activeRowElement.offsetTop - containerHeight / 2;
    let tableElement = document.getElementById("excel-table");
    tableElement.scrollTop = topPos;
  }

  componentDidMount() {
    if (this.props.isActive) {
      this.scrollActiveRowToTopHandler();
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.isActive && this.props.isActive !== prevProps.isActive) {
      //check if active row no is in view.
      //if yes leave it as is.
      //otherwise bring it to view.
      let offsetTopOfSelectedRow = this.rowRef.current.offsetTop;
      let tableElement = document.getElementById("excel-table");

      let scrollTopOfViewer = tableElement.scrollTop;
      let clientHeightOfViewer = tableElement.clientHeight;

      if (
        //extra 52 pixels add for first two fixed rows.
        offsetTopOfSelectedRow > scrollTopOfViewer + 52 &&
        offsetTopOfSelectedRow < scrollTopOfViewer + clientHeightOfViewer
      ) {
      } else {
        this.scrollActiveRowToTopHandler();
      }
    }
  }
  render() {
    const {
      rowData,
      isActive,
      updateActiveRowNo,
      orientation,
      activeRowNo,
      activeColNo,
      headerRow,
      headerColumn,
      updateActiveColNo,
      updateActiveCell,
      activeCell,
    } = this.props;

    //bring row selected to top
    return (
      <tr
        ref={this.rowRef}
        style={{
          border: isActive ? "2px solid #217346" : "",
        }}
      >
        {rowData.map(function (cellData) {
          return (
            <Cell
              key={String(cellData.col_index) + String(cellData.row_index)}
              orientation={orientation}
              activeRowNo={activeRowNo}
              activeColNo={activeColNo}
              activeCell={activeCell}
              headerRow={headerRow}
              headerColumn={headerColumn}
              updateActiveColNo={updateActiveColNo}
              isInActiveRow={isActive}
              isInActiveColumn={activeColNo == cellData.col_index}
              updateActiveRowNo={updateActiveRowNo}
              updateActiveCell={updateActiveCell}
              data={cellData}
            ></Cell>
          );
        })}
      </tr>
    );
  }
};

function areEqual(prevProps, nextProps) {
  if (nextProps.activeRowNo !== null) {
    //prev row selected
    if (prevProps.activeRowNo !== null) {
      if (prevProps.isActive || nextProps.isActive) {
        return false;
      } else return true;
    }
    //prev col selected
    else if (prevProps.activeColNo !== null) {
      return false;
    }
    //prev cell selected
    else if (prevProps.activeCell !== null) {
      if (
        prevProps.activeCell.row_index == nextProps.rowData[0].row_index ||
        nextProps.isActive
      ) {
        return false;
      } else {
        return true;
      }
    }
  } else if (nextProps.activeColNo !== null) {
    return false;
  } else if (nextProps.activeCell !== null) {
    //peviously cell selected
    if (prevProps.activeCell !== null) {
      if (
        nextProps.rowData[0].row_index == prevProps.activeCell.row_index ||
        nextProps.rowData[0].row_index == nextProps.activeCell.row_index
      ) {
        return false;
      } else {
        return true;
      }
    }
    //if previously row selelcted
    if (prevProps.activeRowNo !== null) {
      if (
        prevProps.activeRowNo == nextProps.rowData[0].row_index ||
        nextProps.activeCell.row_index == nextProps.rowData[0].row_index
      ) {
        return false;
      } else {
        return true;
      }
    }
    //prev col selected
    else if (prevProps.activeColNo !== null) {
      return false;
    }
    //misc case
    else {
      return false;
    }
  }
  // nextProps.rowData[0].row_index !=
  //   (nextProps.activeCell && nextProps.activeCell.row_index)
}

const MemorizedRowComponent = React.memo(Row, areEqual);

export default MemorizedRowComponent;
// export default Row;
